<!-- PROGRESS SPINNER -->
<div *ngIf="loadingInvitations || loadingList">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<!-- FILTER -->
<app-devices-vct-list-filters *ngIf="devices && devices.length > 0" [currentSite]="currentSite"
	[deviceFilters]="deviceFilters" (reloadButtonEvent)="onReloadButtonEvent()">
</app-devices-vct-list-filters>
<!-- VCT LIST -->
<div *ngIf="devices && devices.length > 0" class="card px-0 border-round">
	<p-treeTable *ngIf="!loadingInvitations && !loadingList" [value]="devices" [totalRecords]="devices.length"
		(onNodeExpand)="onDeviceExpand($event)" (onNodeCollapse)="onDeviceCollapse($event)"
		[scrollable]="virtualEnableScroll"
		[scrollHeight]="virtualEnableScroll ? '900px' : null"
		[virtualScroll]="virtualEnableScroll"
		[virtualScrollItemSize]="70">
		<ng-template pTemplate="header" let-columns>
			<!-- <tr>
				<th>{{this.screenWidth >= MIN_WIDTH_COL6 ? this.translate.instant('NAME') : ''}}</th>
				<th *ngIf="this.screenWidth >= MIN_WIDTH_COL6">{{ 'DESCRIPTION' | translate }}</th>
				<th [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					{{ 'SUB_GATEWAY_NEW' | translate }}
				</th>
				<th [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					{{ 'STATUS' | translate }}
				</th>
			</tr> -->
		</ng-template>
		<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
			<tr [ttRow]="rowNode" [class]="onExtendedMobile() ? 'flex flex-row' : ''" (click)="selectDevice(rowData.DeviceId, rowNode.level, rowData)"
				[class]="getStyleGatewayPlantRow(rowNode.level)">
				<!-- <td [class]="onExtendedMobile() ? 'flex w-full' : ''"> -->
				<td [class]="onExtendedMobile() ? 'w-6rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<div class="flex align-items-center justify-content-start text-left">
						<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
						<i class="pi {{rowNode.node.icon}} text-4xl text-primary mr-3"></i>
						<div class="text-xl font-medium" style="white-space: pre-wrap">{{ rowData.AliasName !== undefined &&
							rowData.AliasName !== ''? getSplitString(rowData.AliasName) : getSplitString(rowData.Name) |
							truncate:[30]}}</div>
					</div>
				</td>
				<td *ngIf="!onExtendedMobile()" [class]="this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<div class="flex align-items-center justify-content-center text-center">
						<div>{{ getRowInfo(rowData) }}</div>
					</div>
				</td>
				<td [class]="onExtendedMobile() ? 'w-1rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'">
					<!-- TAGS DESKTOP / TABLET -->
					<div *ngIf="!onExtendedMobile()" class="flex flex-row gap-1">
						<!-- OWNER / ASSIGNED TAG -->
						<p-tag *ngIf="showTagShare(rowData)" icon="{{getIconTagShare(rowData)}}" value="{{ getTextTagShare(rowData) }}"
							severity="{{ getSeverityTagShare(rowData) }}"></p-tag>
						<!-- INVITATION TAG -->
						<p-tag *ngIf="showTagShareInvitation(rowData)" icon="{{getIconTagShare(rowData)}}" value="{{ getTextTagShareInvitation(rowData) }}"
							severity="{{ getSeverityTagShareInvitation(rowData) }}"></p-tag>
						<!-- ONLINE / OFFLINE STATUS PLANT OWNER -->
						<p-tag *ngIf="rowNode.level === 0 && this.isPlant(rowData) && this.isOwner(rowData)" [value]="getStatus(rowData.DeviceId)"
							[severity]="getStatusColor(rowData.DeviceId)"></p-tag>
					</div>
					<!-- TAGS MOBILE -->
					<div *ngIf="onExtendedMobile()" class="flex flex-row gap-1">
						<!-- OWNER / ASSIGNED TAG -->
						<p-tag *ngIf="showTagShare(rowData)" icon="{{getIconTagShare(rowData)}}" value=""
							severity="{{ getSeverityTagShare(rowData) }}"></p-tag>
						<!-- INVITATION TAG -->
						<p-tag *ngIf="showTagShareInvitation(rowData)" icon="{{getIconTagShare(rowData)}}" value=""
							severity="{{ getSeverityTagShareInvitation(rowData) }}"></p-tag>
						<!-- ONLINE / OFFLINE STATUS PLANT OWNER -->
						<p-tag *ngIf="rowNode.level === 0 && this.isPlant(rowData) && this.isOwner(rowData)" styleClass="p-tag-mobile"
							[severity]="getStatusColor(rowData.DeviceId)"></p-tag>
					</div>
				</td>
				<!-- td $event.stopPropagation() doesnt open selectDevice for plantRow if click buttons of this td -->
				<td [class]="onExtendedMobile() ? 'w-3rem' : this.screenWidth <= LG_WIDTH ? 'w-9rem' : 'w-12rem'" (click)="$event.stopPropagation()">
					<p-button *ngIf="shareVisible(rowData)"
						pTooltip="{{ isOwner(rowData) ? ('GIVE' | translate) : ('ASSIGN' | translate) }}"
						tooltipPosition="bottom" icon="pi cm-transfer" size="large" (click)="shareDevice(rowData)"
						[rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<p-button *ngIf="editIntercomContactVisible(rowData)" pTooltip="{{ 'INTERCOM_CONTACT' | translate}}"
						tooltipPosition="bottom" icon="pi cm-users" size="large" (click)="editDeviceName(rowData)"
						[rounded]="false" [text]="true" severity="secondary">
					</p-button>
					<p-button *ngIf="editVisible(rowData)" pTooltip="{{ 'EDIT' | translate}}" tooltipPosition="bottom"
						icon="pi cm-pencil" size="large" (click)="editDeviceName(rowData)" [rounded]="false" [text]="true"
						severity="secondary">
					</p-button>
					<p-button *ngIf="abandonVisible(rowData)" pTooltip="{{ 'ABANDON' | translate}}" tooltipPosition="bottom"
						icon="pi cm-cancel" size="large" (click)="abandonDevice(rowData)" [rounded]="false" [text]="true"
						severity="danger">
					</p-button>
					<p-button *ngIf="resetLicenseVisible(rowData)" pTooltip="{{ 'RESET_LICENSE_APP' | translate}}"
						tooltipPosition="bottom" icon="pi cm-reload" size="large" (click)="resetLicense(rowData)"
						[rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button *ngIf="revokeInvitationsVisible(rowData)" pTooltip="{{ 'REVOKE_INVITATION' | translate}}"
						tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="revokeInvitationsDevice(rowData)"
						[rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button *ngIf="revokeAccessVisible(rowData)" pTooltip="{{ 'REVOKE_ACCESS' | translate}}"
						tooltipPosition="bottom" icon="pi cm-cancel" size="large" (click)="revokeAccessDevice(rowData)"
						[rounded]="false" [text]="true" severity="danger">
					</p-button>
					<p-button *ngIf="configAuxCommandsVisible(rowData)" pTooltip="{{ 'AUXILIARY_COMMANDS' | translate}}"
						tooltipPosition="bottom" icon="pi cm-cog" size="large" (click)="configAuxiliaryCommands(rowData)"
						[rounded]="false" [text]="true" severity="secondary">
					</p-button>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage" let-columns>
			<tr>
				<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
			</tr>
		</ng-template>
	</p-treeTable>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>